import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { ProjectPipelineInfo } from '../../model/projectpipeline.model';
import { UpdatePipelineDialogComponent } from '../../component/update-pipeline-dialog/update-pipeline-dialog.component';

@Component({
  selector: 'app-project-pipeline-detail',
  templateUrl: './project-pipeline-detail.component.html',
  styleUrls: ['./project-pipeline-detail.component.css']
})
export class ProjectPipelineDetailComponent implements OnInit {
  projectCode: string;
  projectName: string;
  companyName: string;
  item: ProjectPipelineInfo;
  filteredData: any[] = [];
  
  constructor(
    private dialogRef: MatDialogRef<ProjectPipelineDetailComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.projectCode = data.projectCode;
    this.projectName = data.projectName;
    this.companyName = data.companyName;
    this.item = data.item;
    this.filteredData = data.filteredData || [];
  }

  ngOnInit(): void {
    console.log('Filtered data in dialog:', this.filteredData);
  }

  // Methods for timeline display - same as in the main component
  getHighestPipelineStatus(items: ProjectPipelineInfo[]): number {
    if (!items || items.length === 0) {
      return 0;
    }
    
    let highestStatus = 0;
    for (const item of items) {
      const status = parseInt(item.ProjectPipelineStatusLookupCode || '0');
      if (status > highestStatus) {
        highestStatus = status;
      }
    }
    return highestStatus;
  }

  getLatestPipelineStarStatus(items: ProjectPipelineInfo[]): number {
    if (!items || items.length === 0) {
      return 0;
    }
    
    // The items are already sorted by date (newest first)
    return parseInt(items[0].ProjectPipelineStatusLookupCode || '0');
  }

  openPipelineUpdateDialog(stage: any = null, item: any = {}, isViewMode: boolean = false): void {
    const dialogRef = this.dialog.open(UpdatePipelineDialogComponent, {
      width: '500px',
      autoFocus: false,
      data: {
        stage: stage,
        ProjectSaleCode: item?.ProjectSaleCode ?? null, //must
        ProjectSaleCreateBy: item?.ProjectSaleCreateBy ?? null,
        ProjectPipelineId: isViewMode ? item?.ProjectPipelineId : null,
        ProjectPipelineSubStateCode: isViewMode ? item?.ProjectPipelineSubStateCode : null,
        ProjectPipelineStatusLookupCode: isViewMode ? item?.ProjectPipelineStatusLookupCode : null,
        ProjectPipelineClose: isViewMode ? item?.ProjectPipelineClose : null,
        ProjectPipelineAmount: isViewMode ? item?.ProjectPipelineAmount : null,
        ProjectPipelineComission: isViewMode ? item?.ProjectPipelineComission : null,
        ProjectPipelinePriority: isViewMode ? item?.ProjectPipelinePriority : null,
        ProjectPipelineProbability: isViewMode ? item?.ProjectPipelineProbability : null,
        ProjectPipelineRemark: isViewMode ? item?.ProjectPipelineRemark : null,
        ProjectPipelineCreateBy: isViewMode ? item?.ProjectPipelineCreateBy : null,
        ProjectPipelineFlagDelete: isViewMode ? item?.ProjectPipelineFlagDelete : null,
        ProjectSaleCloseDealProgress: item?.ProjectSaleCloseDealProgress ?? null, //must
        ProjectSaleTeamCode: item?.ProjectSaleTeamCode ?? null,  //must
        ProjectPipelineProjectSaleId: item?.ProjectPipelineProjectSaleId ?? null,  //must
        isViewMode: isViewMode
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.success) {
        if (result.reload) {
          // Close this dialog and tell parent to reload data
          this.dialogRef.close({ reload: true });
        }
      } else if (result?.error) {
        console.error('Error saving pipeline:', result.error);
      }
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
